import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";

// ------------------ COMPONENTES DE BASE--------------------------
import Loader from "../../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getDetallePorAsignacion } from "../../../../../API/Compras/RequisiscionCompras/PurchaseRequestDetails";
import { getRequisaMPorAsignacion } from "../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";
import CrudRequisa from "../../../Compras/Requisas/CrudRequisa/CrudRequisa";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import RequisaMaterialCrud from "../../../Suministros/Bodegas/RequisasMateriales/RequisasMaterialesCRUD/RequisaMaterialCrud";


const RequisasDeAsignaciones = ({item}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [requisasCompras, setRequisasCompras] = useState([]);
  const [requisasMaterial, setRequisasMaterial] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showRequisa, setShowRequisa] = useState(false);
  const [requisaEdit, setRequisaEdit] = useState([]);
  const [habilitarReqCompras, setHabilitarReqCompras] = useState(false);
  const [showRequisaMat, setShowRequisaMat] = useState(false);
  const [habilitarReqMat, setHabilitarReqMat] = useState(false);
  


  const getInfo = async () => {
    setLoading(true);
    let IdOrdenDeTrabajoEnc = item?.IdOrdenDeTrabajoEnc || item?.IdOrdenDeTrabajo

    if(activeIndex === 0){
      const requisasComprasTempo = await getDetallePorAsignacion(IdOrdenDeTrabajoEnc)
      setRequisasCompras(requisasComprasTempo)
    }else{
      const requisasMaterialTempo = await getRequisaMPorAsignacion(IdOrdenDeTrabajoEnc)
      setRequisasMaterial(requisasMaterialTempo)
    }
    setLoading(false);
  };



  const columnsCompras = [
    {
      field: "IdPurcharesRequestDetail",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth?.IdRol === 1,
      frozen: "frozen",
      alignFrozen: "left",
      className: "XXsmall",
    },
    {
      // DateCreated
      field: "DateCreated",
      header: "Fecha Creada",
      headerEn: "Date Create",
      className: "small",
      body: (rowData) => rowData.DateCreated,
      frozen: "frozen",
      Format: "DateTime",
    },
    {
      // ESTADO
      field: "StatusName",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({
        ID: rowData.IdStatus,
        Estado: rowData.StatusName,
      }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {
      // NUMERO ORDEN
      field: "PurchaseRequest",
      header: "No. Requisa",
      headerEn: "No. Requisition",
      className: "small",
      frozen: "frozen",
      Sumary: "count",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        setRequisaEdit(data?.PurchaseRequest)
        setShowRequisa(true);
      },
    },
    {
      // RequestType
      field: "Type",
      header: "Tipo Requisas",
      headerEn: "Request Type",
      className: "small",
      body: (e) => e.Type,
      align: "center",
    },
    {
      // CodigoProducto
      field: "CodigoProducto",
      header: "Código Producto",
      headerEn: "Product Code",
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // NombreProducto
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "Xlarge",
      body: (e) => e.NombreProducto,
    },
    {
      // Description
      field: "Description",
      header: "Decripción",
      headerEn: "Description",
      className: "medium",
      body: (rowData) => rowData.Description,
    },
    {
      // Proveedor
      field: "CustomerName",
      header: "Proveedor",
      headerEn: "Supplier",
      className: "Xlarge",
      body: (rowData) => rowData.IdVendor,
    },
    {
      // PurchaseOrder
      field: "PurchaseOrder",
      header: "Orden Compra",
      headerEn: "Purchase Order",
      className: "small",
      Format: "Modal",
      body: (rowData) => rowData.PurchaseOrder,
      onCellDoubleClicked: ({ data }) => {
        //   OrdenC(data.PurchaseOrder);
      },
    },
    {
      // FechaPOD
      field: "FechaCreado",
      header: "Fecha OC",
      headerEn: "Date PO",
      className: "medium",
      body: (rowData) => rowData.FechaCreado,
      Format: "DateTime2",
    },
    {
      // AgentName
      field: "UserNameAgente",
      header: "Asignado a",
      headerEn: "Assigned to",
      className: "small",
      body: (rowData) => rowData.UserNameAgente,
    },
    {
      // CurrencySymbol
      field: "Currency",
      header: "Moneda",
      headerEn: "Currency",
      className: "Xsmall",
      body: (e) => e.Currency,
      Format: "CurrencySymbol",
      align: "center",
    },
    {
      //UnitSimbol
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      body: (rowData) => rowData.UnitName,
      align: "center",
    },
    {
      // Area
      field: "Area",
      header: "Área",
      className: "medium",
      body: (e) => e.IdArea,
    },
    {
      //ASolicita
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "small",
    },
    {
      //ASolicita
      field: "NombreSubcategoria",
      header: "Categoría",
      headerEn: "Category",
      className: "small",
    },
    {
      //TipoSuministro
      field: "NombreTipoProducto",
      header: "SubCategoría",
      headerEn: "SubCategory",
      className: "small",
    },
    {
      //ASolicita
      field: "UserNameSolicita",
      header: "Solicita",
      headerEn: "Request",
      className: "medium",
      body: (rowData) => rowData.UserName,
    },
    {
      // Quantity
      field: "Quantity",
      header: "Cantidad",
      headerEn: "Quantity",
      className: "Xsmall",
      body: (rowData) => rowData.Quantity,
      Format: "Currency",
      Sumary: "sum",
      frozen: true,
      alignFrozen: "right",
    },
  ];

  const tableCompras = {
    Columns: columnsCompras,
    Data: requisasCompras,
    selected: selected,
    setSelected: setSelected,
    showModal: e => {},
  };

  const columnsMaterial = [
    {
      field: "IdRequisaDet",
      header: "ID",
      headerEn: "ID",
      hidden: userAuth?.IdRol === 1,
      className: "XXsmall",
      frozen: true,
    },
    {
      // Comment
      field: "FechaDet",
      header: "Fecha",
      headerEn: "Date",
      className: "medium",
      frozen: "frozen",
      Format: "DateTime",
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      frozen: true,
      className: "small",
      Format: "Estado",
      body: (rowData) => ({ ID: rowData.IdEstado, Estado: rowData.StatusName }),
    },
    {
      // PurchaseRequest
      field: "Requisa",
      headerEn: "No. Material Requisition",
      header: "No. Requisa Material",
      className: "small",
      body: (rowData) => rowData.Requisa,
      Format: "Modal",
      align: "center",
      Sumary: "count",
      frozen: "frozen",
      onCellDoubleClicked: ({ data }) => {
        setRequisaEdit(data?.Requisa)
        setShowRequisaMat(true);
      },
    },
    {
      // Comment
      field: "CodigoProducto",
      header: "Codigo",
      headerEn: "Code",
      className: "Xsmall",
      body: (rowData) => rowData.CodigoProducto,
    },
    {
      // Comment
      field: "NombreProducto",
      header: "Nombre Producto",
      headerEn: "Product Name",
      className: "Xlarge",
      body: (rowData) => rowData.NombreProducto,
    },
    {
      // Comment
      field: "DescripcionProducto",
      header: "Descripción Producto",
      headerEn: "Description",
      className: "Xlarge",
      body: (rowData) => rowData.NombreProducto,
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type",
      field: "NombreCategoria",
      className: "small",
    },
    {
      header: "Categoría",
      headerEn: "Category",
      field: "NombreSubcategoria",
      className: "small",
    },
    {
      header: "Sub Categoría",
      headerEn: "Sub Category",
      field: "NombreTipoProducto",
      className: "small",
    },
    {
      // Comment
      field: "UnitName",
      header: "Unidad",
      headerEn: "Unit",
      className: "small",
      body: (rowData) => rowData.UnitName,
    },
    {
      header: "Cantidad",
      headerEn: "Amount",
      Sumary: "sum",
      field: "Qty",
      className: "Xsmall",      
      alignFrozen: "right",
      Format: "Currency",
      frozen: true,
    },
  ];

  const tableMaterial = {
    Columns: columnsMaterial,
    Data: requisasMaterial,
    selected: selected,
    setSelected: setSelected,
    showModal: () => {},
  };

  const cerrarConfirmacionCompras = () => {
    if (habilitarReqCompras) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowRequisa(false);
          setRequisaEdit([])
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
      setRequisaEdit([])
    }else{
      setShowRequisa(false);
      setRequisaEdit([])
    }
  };

    const cerrarConfirmacionMat = () => {
    if (habilitarReqMat) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setShowRequisaMat(false);
          setRequisaEdit([])
        },
        rejectLabel: "No",
        reject: () => {},
        style: { backgroundColor: "white" },
      });
    }else{
      setShowRequisaMat(false);
      setRequisaEdit([])
    }
  };


  useEffect(() => {
    getInfo();
  }, [activeIndex]);

  return (
    <div style={{ width: "100%", height: '100%' }}>
      <Loader loading={loading} />
      <Toast ref={toast} />
      <TabView 
        activeIndex={activeIndex}
        onTabChange={(e) => setActiveIndex(e.index)}
      >
        <TabPanel header="Requisas Compras">
            <div className="p-4" style={{ height: "59vh" }}>
                <AgGrid table={tableCompras} />
            </div>
        </TabPanel>

        <TabPanel header="Requisas Materiales">
            <div className="p-4" style={{ height: "59vh" }}>
                <AgGrid table={tableMaterial} />
            </div>
        </TabPanel>
      </TabView>


      <Dialog
        visible={showRequisa}
        onHide={() => {cerrarConfirmacionCompras()}}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <CrudRequisa
          idRequisa={requisaEdit}
          showDialog={showRequisa}
          habilitar={habilitarReqCompras}
          setHabilitar={setHabilitarReqCompras}
        />
      </Dialog>


      <Dialog
        visible={showRequisaMat}
        onHide={() => {cerrarConfirmacionMat()}}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <RequisaMaterialCrud
          idIngreso={requisaEdit}
          setIngresoToShow={() => {}}
          showDialog={showRequisaMat}
          actualizarIngresosScreen={getInfo}
          habilitar={habilitarReqMat}
          setHabilitar={setHabilitarReqMat}
        />
      </Dialog>
   
    </div>
  );
};
export default RequisasDeAsignaciones;
